import {
  makeStyles,
  mergeClasses,
  useFluent,
} from "@fluentui/react-components";

// eslint-disable-next-line no-restricted-imports
import { HighContrastSelector } from "@1js/acui-common/lib/styling/next/commonStyles.styles";

import type { AppIconState } from "./AppIcon.types";
import { useBaseIconStyles } from "../useCommonIconStyles.styles";

const useIconStyles = makeStyles({
  hideIcon: { visibility: "hidden" },
  flip: {
    "-webkit-transform": "scaleX(-1)",
    transform: "scaleX(-1)",
  },
  disabled: {
    opacity: 0.4,
    selectors: {
      [HighContrastSelector]: {
        opacity: 1,
      },
    },
  },
});

export const useAppIconStyles = (state: AppIconState) => {
  const iconStyles = useIconStyles();
  const baseIconStyle = useBaseIconStyles();
  const { dir } = useFluent();
  const isRTL = dir === "rtl";
  const { iconColor, hideIcon, flipInRtl, disabled, shouldFlipIcon } = state;
  const flip = (flipInRtl && isRTL) || shouldFlipIcon;

  if (iconColor) {
    state.root.style = {
      ...state.root.style,
      color: iconColor,
      fill: iconColor,
    };
  }

  state.root.className = mergeClasses(
    baseIconStyle.defaultIcon,
    baseIconStyle.root,
    state.iconClassName,
    hideIcon && iconStyles.hideIcon,
    flip && iconStyles.flip,
    disabled && iconStyles.disabled,
    state.root.className
  );
};
